import { formatCopy } from '../../../../../../utils/clipboard';

export const formatArticleToCopy = ({
  legislationClipboard,
  rawContent,
}: {
  legislationClipboard: string;
  rawContent: string;
}) => {
  const div = document.createElement('div');
  div.innerHTML = rawContent;
  const content = div.textContent || div.innerText || '';
  const text = formatCopy(content.toString().trim(), legislationClipboard);
  return text;
};
